module.exports = __webpack_public_path__ + "files/9c9b62b3a92b1f6bee718e2642d21000.png";